document.addEventListener('DOMContentLoaded', () => {
    const $menuElement = document.getElementById('mainmenu');
    const $navbarBurger = document.getElementById('navbar-burger');
    const $mainmenuList = document.getElementById('mainmenu-list');
    const $html = document.documentElement;

    if (!$menuElement) return;

    if (typeof $navbarBurger !== 'undefined' && typeof $menuElement !== 'undefined' && typeof $mainmenuList !== 'undefined') {
        const $drillLinks = [...$menuElement.querySelectorAll('.mainmenu-drilldownlink')];
        const $backLinks = [...$menuElement.querySelectorAll('.mainmenu-backlink')];

        $navbarBurger.addEventListener('click', (event) => {
            $navbarBurger.classList.toggle('is-active');
            $menuElement.classList.toggle('is-active');
            $html.classList.toggle('is-clipped');
        });

        document.addEventListener('click', (event) => {
            let isClickInside = false;

            if ($menuElement.contains(event.target) || $navbarBurger.contains(event.target)) {
                isClickInside = true;
            }

            if (!isClickInside) {
                $navbarBurger.classList.remove('is-active');
                $menuElement.classList.remove('is-active');
                $html.classList.remove('is-clipped');
            }
        });

        $drillLinks.forEach(drillLink => {
            drillLink.addEventListener('click', (event) => {
                event.preventDefault();
                let $targetMenu = drillLink.nextSibling.nextSibling;
                $targetMenu.classList.add('active');
                $mainmenuList.classList.add('is-drilled');
            }, false);
        });

        $backLinks.forEach(backLink => {
            backLink.addEventListener('click', (event) => {
                event.preventDefault();
                let $targetMenu = event.target.closest('.mainmenu-child');
                $targetMenu.classList.remove('active');
                $mainmenuList.classList.remove('is-drilled');
            }, false);
        });
    }
});
